import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import MarkdownRender from '../text-editors/MarkdownRender';

const MarkdownListDescription = ({ value, className, linkTarget }) => (
  <List.Description className={clsx('aridhia-markdown-list-description', className)}>
    <MarkdownRender value={value} className={className} linkTarget={linkTarget} />
  </List.Description>
);

export default MarkdownListDescription;
